<template>
  <div
    class="HomeRpa bg-white"
    :style="{
      backgroundImage: `url(${ossUrl}/common/rpa_2.0_home/banner-case.png)`,
    }"
  >
    <div class="all">
      <RpaTitle
        style="padding: 58px 0 0px"
        zh="产品介绍"
        en="Product introduction"
      >
      </RpaTitle>
      <div class="flex jcsb aic">
        <div class="bannerTxt">
          <p>
            <span class="RPA fw600">RPA</span>
            <span class="fw600"
              >（Robotic Process Automation，机器人流程自动化）</span
            >
          </p>
          <p>
            <span>
              通过模拟人与计算机的交互，能在任何应用程序上进行鼠标点击、键盘输入、信息
              读取等各种自动化操作。在工作中遇到的重复繁琐、既定规则的标准化流程都可以
              通过RPA实现自动化操作。
            </span>
          </p>
          <p>
            <span>
              国际物流业务涉及委托、运价、订舱、运输、报关、制单、跟踪等多个环节和流程，
              存在大量重复、机械化的手工操作，运用RPA技术，能够不断提升内部工作效率，
              有效降低运作成本，帮助国际物流企业取得更大的竞争优势。
            </span>
          </p>
          <el-button class="downloadBtn" type="primary" @click="toUifoxDownload"
            >免费下载</el-button
          >
        </div>
        <img :src="`${ossUrl}/common/rpa_2.0_home/introduction-1.png`" alt="" />
      </div>
      <RpaTitle
        style="padding: 91px 0 39px"
        zh="国际物流RPA应用场景"
        en="International logistics RPA application scenario"
      >
      </RpaTitle>
      <div class="flex jcsb aifs fww">
        <div v-for="(v, i) in scenarioItems" :key="i" class="scenarioBox">
          <div class="background"></div>
          <div class="imgbox" :style="{ backgroundImage: `url(${v.img})` }">
            <img
              v-if="v.videoSrc"
              class="triangle-left"
              :src="`${ossUrl}/common/rpa_2.0_home/play.png`"
              @click="openVideoPlay(v.videoSrc, v.title)"
            />
          </div>
          <div class="txtBox">
            <div class="title">{{ v.title }}</div>
            <div class="txt">{{ v.text }}</div>
          </div>
        </div>
      </div>

      <RpaTitle style="padding: 52px 0 16px" zh="我们的案例" en="our cases">
      </RpaTitle>

      <!-- <ul class="caseUl flex">
        <li v-for="(v, i) in caseItems"
            :key="i"
            :class="{'active': caseActiveIndex === i}"
            @click="changeCase(i)">{{v.company}}</li>
      </ul> -->
      <div class="caseCarousel">
        <el-carousel
          ref="refCaseCarousel"
          height="482px"
          :interval="5000"
          arrow="never"
          @change="changeCarousel"
        >
          <el-carousel-item v-for="(v, i) in caseItems" :key="i">
            <div class="caseItem flex jcsb">
              <div
                class="img"
                :style="{ backgroundImage: `url(${v.img})` }"
              ></div>
              <div class="txt">
                <p class="company">{{ v.company }}</p>
                <div v-html="v.text"></div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <VideoPlayer
      ref="VideoPlayer"
      :title="videoTitle"
      :visible="videoVisible"
    />
  </div>
</template>

<script>
import VideoPlayer from '../home/components/VideoPlayer.vue'
import { ossUrl, toUifoxDownload } from '@/utils/config.js'
import RpaTitle from '@/components/RpaTitle'
/**
 * RPA详情页
 */
export default {
  name: 'HomeRpa',
  components: { RpaTitle, VideoPlayer },
  data() {
    return {
      ossUrl,
      videoVisible: false,
      videoTitle: '',

      scenarioItems: [
        {
          img: `${ossUrl}/common/rpa_2.0_home/scenario-1.png`,
          title: '智能订舱机器人',
          text: 'RPA机器人自动获取系统中的托书信息，登录对应的船公司网站，自动完成特定规则下的订舱操作',
          videoSrc: `${ossUrl}/video/AutoPreBookingForCOSCO.mp4`,
        },
        {
          img: `${ossUrl}/common/rpa_2.0_home/scenario-2.png`,
          title: '船期查询机器人',
          text: 'RPA机器人自动登录到船期查询网站，批量根据船名查询相应的航次、开截港时间等各类信息',
          videoSrc: `${ossUrl}/video/AutoGetInfoOfDestinationPort.mp4`,
        },
        {
          img: `${ossUrl}/common/rpa_2.0_home/scenario-3.png`,
          title: '数据发送机器人',
          text: 'RPA机器人获取VGM、舱单、AMS等信息，自动登录到数据发送平台完成数据发送操作',
          videoSrc: `${ossUrl}/video/AutoBookingForAMS.mp4`,
        },
        {
          img: `${ossUrl}/common/rpa_2.0_home/scenario-4.png`,
          title: '运价整理机器人',
          text: 'RPA机器人自动将零散的船公司发送过来的运价数据同步到本地系统中，构建集中、高效的运价管理体系',
        },
        {
          img: `${ossUrl}/common/rpa_2.0_home/scenario-5.png`,
          title: '财务对帐机器人',
          text: 'RPA机器人每月月初根据公司财务对账规则，自动从系统中获取并核对上月交易明细，无误后自动生成对账单',
        },
        {
          img: `${ossUrl}/common/rpa_2.0_home/scenario-6.png`,
          title: '财务开票机器人',
          text: 'RPA机器人自动从业务系统中获取完整的开票信息，然后在开票软件中完成开票操作，并通知相关财务人员',
        },
      ],
      caseItems: [
        {
          company: '欧坚网络',
          img: `${ossUrl}/common/rpa_2.0_home/case-1.png`,
          text: `上海欧坚网络发展集团股份有限公司是中国最大的国际物流报关企业之一，主营业务包括跨境物流、跨境贸易、跨境清关、物流运输等在内的综合国际物流服务。目前，欧坚集团正利用互联网技术全方面为企业或个人提供“四位一体”的线上、线下通关服务。<br/>
                  未斯科技在与欧坚集团的沟通中发现，他们操作人员每天需要处理海量的纸质报关资料（报关委托书、报关单、销售合同、发票等），操作流程复杂，工作效率低下。因此，借助RPA机器人和OCR识别能力一键自动识别纸质报关单材料，并自动将报关信息录入集团系统中，不仅提升了操作人员的工作效率，降低了集团人力成本，而且为客户提供了更加高效、便捷的智能化服务。`,
        },
        {
          company: '大木国际物流集团',
          img: `${ossUrl}/common/rpa_2.0_home/case-2.png`,
          text: `大木国际物流集团有限公司成立于2001年，总部在上海。主营业务包含国际货运代理、船舶代理、场站仓配等多个国际物流配套服务。已先后在全国十几个主要港口和城市建立了多家分公司，并与全球70多个国家和地区的海外代理建立了长期良好的合作关系。<br/>
                未斯科技积极参与到大木集团数字化建设中，在充分了解具体业务流程后，主导开发COSCO/马士基/OOCL/ONE自动订舱、运价自动管理、物流跟踪信息查询等流程，在帮助大木集团降本增效的同时，有效提升了集团内外业务协同效率，使其业务朝着数字化和智能化方向发展。`,
        },
        {
          company: '上海亚凯',
          img: `${ossUrl}/common/rpa_2.0_home/case-3.png`,
          text: `上海亚凯国际货物运输代理有限公司，是经国际商务部批准的一级国际货运代理企业，并获得交通部批准的无船承运人。公司在2005年成立于上海，是一家上海老牌知名货代企业<br/>
                随着海运业务蓬勃发展，COSCO/ONE/OOCL/马士基/MSA等热门航线舱位信息常常供不应求，往往需要安排专人提前跟进放舱通知，并及时完成热门航线订舱操作。但是订舱流程需要填录的信息繁多，人工重复操作不仅速度太慢，容易错失紧俏舱位，而且极易出错。上海亚凯就存在以上痛点，严重影响公司业务运作，现在借助未斯科技打造的智能订舱机器人，订舱人员只需提前填好订舱需求和订舱规则，并设置自动执行时间，由RPA机器人智能完成整个订舱操作，省时省力省心。`,
        },
      ],
      caseActiveIndex: 0,
    }
  },
  methods: {
    toUifoxDownload,
    changeCase(index) {
      this.caseActiveIndex = index
      this.$refs.refCaseCarousel.setActiveItem(index)
    },
    changeCarousel(index) {
      this.caseActiveIndex = index
    },
    openVideoPlay(src, title) {
      this.videoVisible = true
      this.videoTitle = title
      this.$refs.VideoPlayer.playerOptions.sources[0].src = src
      setTimeout(() => {
        this.$refs.VideoPlayer.$refs.videoPlayer.player.play()
      }, 100)
    },
  },
}
</script>

<style lang="scss" scoped>
.bg-white {
  background-color: #fff;
}
.flex {
  display: flex;
}
.jcsb {
  justify-content: space-between;
}
.aifs {
  align-items: flex-start;
}
.aic {
  align-items: center;
}
.fww {
  flex-wrap: wrap;
}
.fw600 {
  font-weight: 600;
}
.all {
  width: 1200px;
  margin: 0 auto 0;
}
.HomeRpa {
  font-size: 16px;
  letter-spacing: 2px;
  color: #333;
  background-position: center calc(100% + 410px);
  background-repeat: no-repeat;
  .bannerTxt {
    min-width: 666px;
    width: 666px;
    line-height: 32px;
    .RPA {
      font-size: 26px;
      line-height: 32px;
    }
    .downloadBtn {
      width: 188px;
      height: 52px;
      font-size: 20px;
      font-weight: 500;
      border-radius: 31px;
      margin-top: 30px;
      background-color: #0f71ef;
    }
  }
  .scenarioBox {
    position: relative;
    width: 360px;
    height: 426px;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    margin-bottom: 30px;
    border-radius: 20px;
    overflow: hidden;
    .imgbox {
      position: relative;
      width: 100%;
      height: 245px;
      background-position: bottom center;
      background-repeat: no-repeat;
      margin-bottom: 38px;
      z-index: 1;
      img {
        position: absolute;
        top: 95px;
        left: 50%;
        transform: translateX(-50%);
        cursor: pointer;
      }
    }
    .txtBox {
      height: 143px;
      z-index: 1;
      .title {
        line-height: 33px;
        font-size: 24px;
        font-weight: 500;
      }
      .txt {
        padding: 16px 17px 0;
      }
    }
    .background {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: #fff;
      opacity: 0;
      z-index: 0;
      transition: background 0.7s;
    }
    &:hover {
      color: #fff;
      .background {
        background: linear-gradient(
          180deg,
          #cbecff 0%,
          #75b6ff 53%,
          #0f71ef 100%
        );
        opacity: 1;
        z-index: 0;
      }
    }
  }

  .caseUl {
    justify-content: center;
    margin-bottom: 40px !important;
    li {
      font-size: 24px;
      line-height: 33px;
      margin: 0 22px;
      color: #666;
      cursor: pointer;
      &:hover,
      &.active {
        color: #0f71ef;
      }
    }
  }
  .caseCarousel {
    padding-bottom: 30px;
  }
  .caseItem {
    align-items: center;
    .img {
      width: 519px;
      height: 416px;
      background-position: center left;
      background-repeat: no-repeat;
    }
    .txt {
      width: 666px;
      line-height: 30px;
      .company {
        font-size: 26px;
        font-weight: 500;
        padding-bottom: 4px;
      }
    }
  }
}

::v-deep.el-carousel {
  .is-active button {
    background-color: #1170eb !important;
  }
  .el-carousel__indicators {
    .el-carousel__indicator {
      padding: 33px 8px;

      .el-carousel__button {
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background-color: #d8d8d8;
      }
    }
  }
}
</style>
